export const EmailIcon = () => (
  <svg
    data-test="icon-telephone"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M20.4727 15.9766L16.5352 14.2891C16.4297 14.2539 16.2891 14.2188 16.1836 14.2188C15.9727 14.2188 15.6914 14.3594 15.5508 14.5352L13.793 16.6797C11.4727 15.5547 8.66016 12.7773 7.57031 10.457L9.71484 8.69922C9.89062 8.55859 10.0312 8.27734 10.0312 8.03125C10.0312 7.96094 9.99609 7.82031 9.96094 7.71484L8.27344 3.77734C8.13281 3.49609 7.78125 3.28516 7.46484 3.28516C7.42969 3.28516 7.35938 3.28516 7.28906 3.28516L3.63281 4.12891C3.28125 4.19922 3 4.58594 3 4.9375C3 13.9727 10.2773 21.25 19.3125 21.25C19.6641 21.25 20.0508 20.9688 20.1211 20.6172L20.9648 16.9609C20.9648 16.8906 20.9648 16.8203 20.9648 16.7852C20.9648 16.4688 20.7539 16.1172 20.4727 15.9766Z"
    />
  </svg>
);
